export default __webpack_public_path__ + "static/media/5.d9b6a21f.svg";